/**
 * Custom Display Component for displaying a text box as a link. The contents of the field will be treated as a URL
 */
import React, {useState} from 'react';

import {FieldProp} from '../../types';
import {DisplayOnly} from './DisplayOnly';
import {Modal} from '../Modal';

type ImageProps = FieldProp & {};

export const Image: React.FunctionComponent<ImageProps> = ({
                                                               field,
                                                               value,
                                                           }): JSX.Element => {
    const [showModal, setShowModal] = useState<boolean>(false);

    const imageContentSource = field?.flowCustomDisplayComponentConfig?.contentSource === 'base64' ? 'base64' : 'url';
    // replace the data:image/png;base64,
    const imageUrl = imageContentSource === 'base64' ? value : value;
    return (
        <div>
            {value &&
            <DisplayOnly>
                <img src={imageUrl}
                     style={{
                         maxWidth: '100%',
                         height: '250px',
                         cursor: 'pointer'
                     }}
                     onClick={() => setShowModal(true)}
                />
            </DisplayOnly>
            }
            {showModal &&
            <Modal size="xl">
                <div className="modal-body">
                    <img src={imageUrl}
                         style={{
                             maxWidth: '100%',
                         }}
                         onClick={() => setShowModal(false)}
                    />
                </div>
            </Modal>
            }
        </div>
    );
}
;
